import {
  BlankSlate as BlankSlateBase,
  BlankSlateActions,
  BlankSlateDescription,
  BlankSlateIcon,
  BlankSlateImage,
  BlankSlateTitle,
  Box,
  Button,
} from "@prismicio/editor-ui"

import { pageBuilderLivePreviewDocsUrl } from "../../../../app/constants"
import prismicAi from "./prismic-ai.svg"

type BlankSlateProps =
  | {
      type: "waiting"
      title: string
      cancel: () => void
    }
  | { type: "error"; retry: () => void }
  | {
      type: "simulatorMissing"
    }

export function BlankSlate(props: BlankSlateProps) {
  const { type } = props

  let image
  switch (type) {
    case "waiting":
      image = (
        <BlankSlateImage fixedHeight={false}>
          <img
            src={prismicAi}
            alt="The head of a robot with the shape of the Prismic logo."
          />
        </BlankSlateImage>
      )
      break
    case "error":
    case "simulatorMissing":
      image = (
        <BlankSlateIcon
          name="alert"
          lineColor="grey1"
          backgroundColor="purple9"
        />
      )
      break
  }

  let title
  switch (type) {
    case "waiting":
      title = props.title
      break
    case "error":
      title = "Something went wrong"
      break
    case "simulatorMissing":
      title =
        "Live preview is necessary to generate slices with AI, but has not been configured"
      break
  }

  let description
  switch (type) {
    case "waiting":
      description = "This may take a few seconds"
      break
    case "error":
      description = "We encountered an error while generating the slices"
      break
    case "simulatorMissing":
      description = "Learn how to set it up in this documentation"
      break
  }

  let actions
  switch (type) {
    case "waiting":
      actions = <Button onClick={props.cancel}>Cancel</Button>
      break
    case "error":
      actions = <Button onClick={props.retry}>Try again</Button>
      break
    case "simulatorMissing":
      actions = (
        <Button
          onClick={() => window.open(pageBuilderLivePreviewDocsUrl, "_blank")}
        >
          View documentation
        </Button>
      )
      break
  }

  return (
    <Box padding={{ block: 100 }} flexDirection="column">
      <BlankSlateBase>
        {image}
        <BlankSlateTitle size="big">{title}</BlankSlateTitle>
        <BlankSlateDescription>{description}</BlankSlateDescription>
        <BlankSlateActions>{actions}</BlankSlateActions>
      </BlankSlateBase>
    </Box>
  )
}
